const hauptInfo = [
  {
    id: 1,
    type: "jugend",
    situation: "new",
    titel: "Zukunftswege – Gemeinsam gestalten",
    titelAlt: "( Ein Jugendclub für Kinder im Harmonie Kulturzentrum Neuss )",
    desc: "Im Rahmen des Förderprogramms „2.000 x 1.000 Euro für das Engagement – Engagiert NRW“ wurde im Harmonie Kulturzentrum Neuss das Projekt „Zukunftswege – Gemeinsam gestalten“ erfolgreich umgesetzt.",
    desc2:
      "Ziel des Projekts war es, Kinder im Alter von 9 bis 13 Jahren frühzeitig für freiwilliges Engagement und gesellschaftliche Teilhabe zu sensibilisieren. Besonders Kinder aus Familien mit Migrationsgeschichte wurden ermutigt, sich aktiv einzubringen, Verantwortung zu übernehmen und gemeinsam mit anderen etwas zu bewegen.",
    desc3:
      "Das Projekt startete mit einer Auftaktveranstaltung, an der auch die Familien der Kinder beteiligt waren. Durch die Einbindung der Eltern konnte von Beginn an eine hohe Motivation und eine starke Identifikation mit dem Projekt erreicht werden. In einer offenen und wertschätzenden Atmosphäre wurden die Ziele des Projekts vorgestellt und erste Gespräche zum Thema Ehrenamt geführt.",
    desc4:
      "In den darauffolgenden monatlichen Treffen arbeiteten die Kinder in begleiteten Workshops zu Themen wie Teilhabe, Mitbestimmung und gemeinsames Planen. Dabei standen erfahrungsorientiertes Lernen, Teamarbeit und aktive Beteiligung im Mittelpunkt. Die Kinder lernten, eigene Ideen zu äußern, Aufgaben zu übernehmen und Entscheidungen gemeinsam zu treffen.",
    desc5:
      "Im weiteren Projektverlauf bildete sich aus den Teilnehmenden eine feste Kinder- und Jugendgruppe, die gemeinsam plante und konkrete Aktionen entwickelte. Ein zentrales Ergebnis war die Entscheidung, Geschenkpakete für andere Kinder in schwierigen Lebenssituationen vorzubereiten. Die Kinder gestalteten diese Pakete eigenständig, verpackten und dekorierten sie gemeinsam und erlebten dabei ganz praktisch, was es bedeutet, sich freiwillig für andere einzusetzen.",
    desc6:
      "Zum Abschluss des Projekts fand eine gemeinsame Reflexionsrunde statt. Die Kinder berichteten von ihren Erfahrungen, äußerten den Wunsch, die Gruppe fortzuführen, und entwickelten erste Ideen für zukünftige Aktivitäten. Damit wurde der Grundstein für einen nachhaltigen Kinder- und Jugendclub im Harmonie Kulturzentrum gelegt.",
    desc7:
      "Das Projekt zeigte eindrucksvoll, wie wichtig frühe Beteiligungserfahrungen für Kinder sind. Es stärkte Selbstvertrauen, soziale Kompetenzen und das Bewusstsein dafür, dass jede und jeder einen Beitrag zum gesellschaftlichen Zusammenhalt leisten kann.",
    desc8: <strong>Dank</strong>,
    desc9:
      "Wir bedanken uns herzlich beim Förderprogramm „2.000 x 1.000 Euro für das Engagement“ sowie beim Engagement-Portal des Landes Nordrhein-Westfalen für die Unterstützung dieses Projekts. Ein besonderer Dank gilt außerdem allen beteiligten Kindern, Familien und Unterstützenden, die mit ihrem Engagement zum Erfolg von „Zukunftswege – Gemeinsam gestalten“ beigetragen haben.",
    image: "/images/projekte/engagement/engagementHarmonie.jpeg",
    video: "",
    images: [
      "/images/projekte/engagement/engagementHarmonie.jpeg",
      "/images/projekte/engagement/engagement1 (1).jpeg",
      "/images/projekte/engagement/engagement1 (2).jpeg",
      "/images/projekte/engagement/engagement3 (4).jpeg",
    ],
    time: "...",
  },
  {
    id: 2,
    date: "01.10.2025 – 31.10.2025",
    type: "integration",
    situation: "new",
    titel: "„ Bilder aus der neuen Heimat “ – Neuss durch die Augen der Kinder",
    titel2: "bilderVonHeimat",
    desc: " ",
    desc2:
      "Im Rahmen der Herbstferien vom 20. bis 24. September 2025 haben wir unser Projekt „Bilder aus der neuen Heimat“ erfolgreich durchgeführt. Ziel war es, zugewanderten Kindern einen kreativen Zugang zu ihrer neuen Stadt Neuss zu ermöglichen.",
    desc3:
      "Ein neues Land, eine neue Sprache, eine neue Kultur – für viele zugewanderte Kinder bedeutet dieser Schritt eine große Herausforderung. Mit unserem Projekt wollten wir ihnen eine neue Perspektive eröffnen.",
    desc4:
      "16 Kinder im Alter von 10 bis 14 Jahren machten sich mit der Kamera auf den Weg, ihre neue Umgebung zu entdecken. Von alltäglichen Momenten bis hin zu besonderen Orten hielten sie ihre Eindrücke fotografisch fest – und gaben damit einen einzigartigen Einblick in ihre ersten Erfahrungen in der neuen Heimat.",
    desc5:
      "Die Fotografie wurde dabei zu einer Sprache ohne Worte: Sie half den Kindern, Gefühle auszudrücken, die oft schwer in Worte zu fassen sind. Durch die Gestaltung von Plakaten und Präsentationen stärkten sie ihre Kreativität, ihr Selbstvertrauen und ihre Sprachkompetenzen. Gleichzeitig förderte die Gruppenarbeit den Teamgeist und die soziale Integration.",
    desc6:
      "Das sichtbar gewachsene Selbstbewusstsein und die Freude in den Gesichtern der Kinder waren der schönste Beweis für den Erfolg des Projektes. Neuss ist für sie nicht mehr nur ein Wohnort – sondern ein Ort, an dem sie sich zuhause fühlen können.",
    desc7:
      "Unser besonderer Dank gilt dem <b>Deutschen Kinderhilfswerk</b>, das dieses wertvolle Projekt ermöglicht hat.",
    image: "/images/projekte/heimat/heimat-1.jpg",
    video: "",
    images: [
      "/images/projekte/heimat/heimat-1.jpg",
      "/images/projekte/heimat/heimat-2.jpeg",
      "/images/projekte/heimat/heimat-3.jpeg",
      "/images/projekte/heimat/heimat-4.jpeg",
      "/images/projekte/heimat/heimat-5.jpeg",
      "/images/projekte/heimat/heimat-6.jpeg",
      "/images/projekte/heimat/heimat-7.jpeg",
      "/images/projekte/heimat/heimat-8.jpeg",
      "/images/projekte/heimat/heimat-9.jpeg",
      "/images/projekte/heimat/heimat-10.jpeg",
      "/images/projekte/heimat/heimat-11.jpeg",
    ],
    time: "...",
  },
  {
    id: 3,
    date: "",
    type: "integration",
    situation: "new",
    titel: "„ Job Messe “ – Ein erfolgreicher Beratungstag in Neuss",
    desc: "📍 Ort: Zufuhrstraße 2, 41462 Neuss",
    desc2:
      "Die von unserem Verein organisierte Job-Messe wurde mit großer Interesse angenommen und mit Erfolg durchgeführt. Ziel dieses besonderen Beratungstags war es, Zugewanderten, die in jüngerer Zeit nach Deutschland gekommen sind, bei ihrer beruflichen Orientierung und Integration zu unterstützen.",
    desc3: "🎯 Ziel der Veranstaltung",
    desc4:
      "Das Hauptziel bestand darin, Menschen mit Fluchterfahrung, die ihre Sprachförderung abgeschlossen haben und in Deutschland beruflich Fuß fassen möchten, konkrete Einblicke und Orientierungsmöglichkeiten zu bieten. Durch den Austausch mit Fachkräften, die ähnliche Wege gegangen sind, erhielten die Teilnehmenden wertvolle Informationen, Motivation und neue Perspektiven für ihre berufliche Zukunft.",
    desc5: "📚 In welchen Bereichen wurden Seminare angeboten?",
    desc6:
      "Parallel fanden in vier Räumen berufsbezogene Seminare statt. Fachkräfte aus verschiedenen Berufsfeldern, die bereits erfolgreich im deutschen Arbeitsmarkt tätig sind, berichteten über ihre persönlichen Erfahrungen. Themenbereiche waren u. a.:",
    desc61:
      "🔹Lehramt und Bildungsarbeit (Lehrkräfte, Schulbegleiter*in, Herkunftssprachlicher Unterricht)",
    desc62:
      "🔹Sprachförderung und Integrationskurse (DaF-DaZ, Integrationskurslehrer*in)",
    desc63:
      "🔹Soziale Arbeit (Sozialarbeiter*in, Alltagshelfer*in, Sozialbetreuer*in in Flüchtlingseinrichtungen)",
    desc64:
      "🔹Kinderbetreuung und pädagogische Angebote (Erzieher*in, OGS, MPT-Phasen)",
    desc65:
      "🔹Berufliche Anerkennung und pädagogische Qualifizierung (OBAS, Pädagogische Einführung)",
    desc7: "🛠️ Ablauf der Veranstaltung",
    desc8:
      "In insgesamt 16 Sitzungen konnten die Teilnehmenden je nach Interessensgebiet Seminare besuchen. Die Referent*innen erzählten aus erster Hand über ihren Weg – vom Spracherwerb bis zum Berufseinstieg – über Herausforderungen, Anerkennungsverfahren und Chancen im jeweiligen Berufsfeld. In anschließenden Fragerunden wurden individuelle Anliegen aufgenommen und beantwortet.",
    desc9:
      "Die Teilnehmenden erhielten dabei nicht nur fachliche Orientierung, sondern konnten ihre eigenen Ziele klarer definieren und sich aktiv mit ihrer beruflichen Zukunft auseinandersetzen.",
    desc10: "💬 Teilnehmerstimmen und Ausblick",
    desc11:
      "Die Rückmeldungen der Teilnehmenden waren durchweg positiv. Die Inhalte wurden als informativ, motivierend und praxisnah beschrieben. Besonders geschätzt wurden die persönlichen Berichte der Referent*innen, die selbst Migrationserfahrungen gemacht haben und somit authentisch von ihrem beruflichen Werdegang berichten konnten.",
    desc12:
      "Mehrfach wurde der Wunsch geäußert, solche Beratungsformate nicht als einmaliges Ereignis, sondern regelmäßig über das Jahr hinweg anzubieten – themenspezifisch und nachhaltig.",
    desc13:
      "Als Verein sehen wir es als unsere Verantwortung, diese wichtige Arbeit weiterzuführen und auszubauen. Wir möchten langfristig ein strukturiertes, niedrigschwelliges und wirkungsvolles Beratungsangebot schaffen, das Zugewanderten den beruflichen Einstieg erleichtert und ihnen zeigt: „Ihr seid nicht allein.“",
    desc14:
      "Unser Ziel ist es, Menschen auf ihrem Weg in ein selbstbestimmtes, beruflich erfülltes Leben in Deutschland zu begleiten – mit Wissen, Erfahrung und einem offenen Ohr.",
    image: "/images/marketing/marketing-concept-figures.jpg",
    video: "",
    images: [
      "/images/marketing/marketing-concept-figures.jpg",
      "/images/marketing/Image-1.jpeg",
      "/images/marketing/Image-2.jpeg",
      "/images/marketing/Image-3.jpeg",
      "/images/marketing/Image-4.jpeg",
      "/images/marketing/Image-5.jpeg",
    ],
    time: "...",
  },
  {
    id: 4,
    date: "01.02.2025 – 16.03.2025",
    type: "jugend",
    situation: "new",
    titel: "„ Junge Stimmen für die Demokratie “ ",
    desc: " ",
    desc2:
      "Das Projekt „Junge Stimmen für die Demokratie“, unterstützt vom Deutschen Kinderhilfswerk, wurde mit großer Begeisterung durchgeführt und stieß bei unseren Schülern auf großes Interesse. Im Rahmen des Projekts nahmen 25 Schüler aktiv teil und es wurden vier Treffen organisiert, bei denen eine kleine Wahlsimulation durchgeführt wurde.",
    desc3:
      "Durch dieses Projekt hatten die Jugendlichen die Gelegenheit, wichtige Begriffe rund um Demokratie und deren Werte zu erlernen. Außerdem erlebten sie einen Wahlprozess, indem sie in selbst gebildeten Gruppen zusammenarbeiteten. Während des Projekts nahmen die Schüler an Wahlvorbereitungen teil, erstellten Plakate, setzten sich Ziele und präsentierten sich sowie ihre politischen Programme in einer Diskussionsrunde.",
    desc4:
      "Die wahlberechtigten Schüler hatten die Möglichkeit, den Präsidentschaftskandidaten Fragen zu stellen und sie näher kennenzulernen, bevor sie ihre Stimme abgaben. Beim finalen Treffen des Projekts wählten die Schüler durch ihre Stimme den Präsidenten sowie die stellvertretenden Präsidenten, die sie vertreten sollten.",
    desc5:
      "Dieses Projekt bot unseren Schülern die Möglichkeit, ein tieferes Verständnis für die Bedeutung der Demokratie zu entwickeln. Zudem konnten sie grundlegende demokratische Prinzipien wie Wahlrecht, Pluralismus und die Bedeutung demokratischer Werte besser begreifen.",
    image: "/images/jugend/demokratie-stimme/demokratie-1.jpg",
    video: "",
    images: [
      "/images/jugend/demokratie-stimme/demokratie-1.jpg",
      "/images/jugend/demokratie-stimme/demokratie-2.jpg",
      "/images/jugend/demokratie-stimme/demokratie-3.jpg",
      "/images/jugend/demokratie-stimme/demokratie-4.jpg",
      "/images/jugend/demokratie-stimme/demokratie-5.jpg",
      "/images/jugend/demokratie-stimme/demokratie-6.jpg",
      "/images/jugend/demokratie-stimme/demokratie-7.jpg",
    ],
    time: "...",
  },
  {
    id: 5,
    date: "Samstags",
    type: "jugend",
    situation: "new",
    titel: "Handwerkliche Aktivitäten",
    desc: "Harmonie e.V. bietet Kindern während des Schuljahres 2023 - 2024 spezielle Handwerks-und Werkstattangebote einer besonderen Art an. In einer Zeit, in der sich die Kinder vermehrt individuellen Spielen aufgrund der Digitalisierung widmen, tragen unsere Aktivitäten nicht nur dazu bei, dass sie neue Erfahrungen sammeln, sondern fördern das Miteinander und tragen somit auch zur Entwicklung des Teamgeistes bei.",
    desc2:
      "Harmonie e.V. bietet Kindern während des Schuljahres 2023 - 2024 spezielle Handwerks-und Werkstattangebote einer besonderen Art an. In einer Zeit, in der sich die Kinder vermehrt individuellen Spielen aufgrund der Digitalisierung widmen, tragen unsere Aktivitäten nicht nur dazu bei, dass sie neue Erfahrungen sammeln, sondern fördern das Miteinander und tragen somit auch zur Entwicklung des Teamgeistes bei. Erfahrene Betreuer begleiten die Kinder während der Aktivitätsstunden, in denen jede Woche verschiedene handwerkliche Fähigkeiten erlernt werden. Dank dieser Palette an Angeboten können die Kinder nicht nur ihre eigene Kreativität entdecken, sondern auch Erfahrung sammeln. Um sicherzustellen, dass die Kinder im Schuljahr 2023 - 2024 eine unterhaltsame und lehrreiche Zeit verbringen, sind wir für die Kinder stets da.",
    desc3:
      "Die wahlberechtigten Schüler hatten die Möglichkeit, den Präsidentschaftskandidaten Fragen zu stellen und sie näher kennenzulernen, bevor sie ihre Stimme abgaben. Beim finalen Treffen des Projekts wählten die Schüler durch ihre Stimme den Präsidenten sowie die stellvertretenden Präsidenten, die sie vertreten sollten.",
    desc4: "Veranstaltungszeitraum: Jeden Samstag von 10:30 Uhr - 13:30 Uhr",
    image:
      "https://cdn.pixabay.com/photo/2016/06/09/02/42/crayons-1445053_640.jpg",
    video: "",
    images: [
      "/images/jugend/jFoto-1.png",
      "/images/jugend/jFoto-2.jpg",
      "/images/jugend/jFoto-3.jpg",
      "/images/jugend/jFoto-4.jpg",
      "/images/jugend/jFoto-5.jpg",
      "/images/jugend/jFoto-6.jpg",
    ],
    time: "...",
  },
  // {
  //   id: 4,
  //   type: "newss",
  //   situation: "old",
  //   titel: "Titel über aktuelle Daten (1)",
  //   desc: "Wöchentliche oder monatliche Entwicklungen im Verein können in diesem Bereich, unterstützt durch Bilder und Kurzinformationen, ausgestellt werden...",
  //   desc2:
  //     "",
  //   image:
  //     "https://cdn.pixabay.com/photo/2023/10/25/19/25/blue-8341156_640.jpg",
  //   video: "",
  //   images: [
  //     "/images/news/nFoto-1.jpg",
  //     "/images/news/nFoto-2.jpg",
  //     "/images/news/nFoto-3.jpg",
  //     "/images/news/nFoto-4.jpg",
  //     "/images/news/nFoto-5.jpg",
  //     "/images/news/nFoto-6.jpg",
  //   ],
  //   time: "...",
  // },
  // {
  //   id: 5,
  //   date: "",
  //   type: "newss",
  //   situation: "old",
  //   titel: "Titel über aktuelle Daten",
  //   desc: "Wöchentliche oder monatliche Entwicklungen im Verein können in diesem Bereich, unterstützt durch Bilder und Kurzinformationen, ausgestellt werden...",
  //   desc2:
  //     "",
  //   image:
  //     "https://cdn.pixabay.com/animation/2023/03/28/02/15/02-15-52-868_512.gif",
  //   video: "",
  //   images: [
  //     "/images/news/nFoto-7.jpg",
  //     "/images/news/nFoto-8.jpg",
  //     "/images/news/nFoto-9.jpg",
  //     "/images/news/nFoto-10.jpg",
  //     "/images/news/nFoto-11.jpg",
  //     "/images/news/nFoto-12.jpg",
  //   ],
  //   time: "...",
  // },
  // {
  //   id: 6,
  //   type: "newss",
  //   situation: "old",
  //   titel: "Titel über aktuelle Daten (3)",
  //   desc: "Wöchentliche oder monatliche Entwicklungen im Verein können in diesem Bereich, unterstützt durch Bilder und Kurzinformationen, ausgestellt werden...",
  //   desc2:
  //     "",
  //   image:
  //     "https://cdn.pixabay.com/animation/2022/11/13/07/16/07-16-41-513_512.gif",
  //   video: "",
  //   images: [
  //     "/images/news/nFoto-7.jpg",
  //     "/images/news/nFoto-8.jpg",
  //     "/images/news/nFoto-9.jpg",
  //     "/images/news/nFoto-10.jpg",
  //     "/images/news/nFoto-11.jpg",
  //     "/images/news/nFoto-12.jpg",
  //   ],
  //   time: "...",
  // },
  // {
  //   id: 7,
  //   type: "bildung",
  //   situation: "old",
  //   titel: "Hier kommt Schlagzeile",
  //   desc: "Alle Bildungsaktivitäten des Vereins können in diesem Bereich umfassend präsentiert werden. Unterstützt durch aussagekräftige Videos oder Fotos wird ein lebendiges Bild unserer vielfältigen Veranstaltungen gezeichnet.",
  //   desc2:
  //     "",
  //   image:
  //     "https://cdn.pixabay.com/photo/2024/02/12/20/05/ai-generated-8569498_640.png",
  //   video: "",
  //   images: [
  //     "/images/bildung/bFoto-1.png",
  //     "/images/bildung/bFoto-2.png",
  //     "/images/bildung/bFoto-3.jpg",
  //     "/images/bildung/bFoto-4.jpg",
  //     "/images/bildung/bFoto-5.jpg",
  //     "/images/bildung/bFoto-6.jpg",
  //   ],
  //   time: "...",
  // },
  {
    id: 6,
    date: "09.03.2024",
    type: "dialog",
    situation: "old",
    titel: "Hacivat & Karagöz",
    desc: "Harmonie e.V. hat in diesem Jahr eine ganz besondere Veranstaltung organisiert. Um das Glück der Kinder und ihr Interesse an Kunst zu vereinbaren, fanden ein der traditionell türkischen Kultur das Puppenspiel des Hacivat und Karagöz und darüber hinaus noch ein Schattenspiel statt.",
    desc2:
      "Harmonie e.V. hat in diesem Jahr eine ganz besondere Veranstaltung organisiert. Um das Glück der Kinder und ihr Interesse an Kunst zu vereinbaren, fanden ein der traditionell türkischen Kultur das Puppenspiel des Hacivat und Karagöz und darüber hinaus noch ein Schattenspiel statt. Wo bunte und fröhliche Charaktere zum Leben erweckt wurden, hatten die Kinder nicht nur eine unterhaltsame Zeit, sondern auch die Gelegenheit, die traditionell türkische Kunst näher kennenzulernen. Die Dialoge zwischen dem klugen Hacivat und dem scherzhaften Karagöz zauberten ein Lächeln auf die Gesichter der Kinder und brachten sie somit zum Strahlen. Diese Veranstaltung war jedoch nicht nur auf die Vorführung beschränkt. Bei unserer Veranstaltung, bei der nicht nur die türkische Tradition des Schattenspiels in Vordergrund stand umfasste auch das Puppenspiel, welches die Fantasie der Kinder anregte und somit eine unvergessliche Reise in die magische Welt der Kunst ermöglichte. Für die Teilnahme an so einem tollen und kunstvollen Veranstaltung bedanken wir uns recht herzlichst bei allen Mitwirkenden.",
    desc3:
      "Das traditionelle türkische Schattenspiel -Hacivat und Karagöz- wurde 2009 von der UNESCO als immaterielles Kulturerbe anerkannt und in die Liste der immateriellen Kulturerbe aufgenommen",
    image: "/images/dialog/hacivat/hFoto-1.jpeg",
    video: "/images/dialog/hacivat/hVideo-1.mp4",
    images: [
      "/images/dialog/hacivat/hFoto-1.jpeg",
      "/images/dialog/hacivat/hVideo-1.mp4",
      "/images/dialog/hacivat/hVideo-2.mp4",
      "/images/dialog/hacivat/hFoto-2.jpeg",
      "/images/dialog/hacivat/hFoto-3.jpeg",
      "/images/dialog/hacivat/hFoto-4.jpeg",
    ],
    time: "...",
  },
  {
    id: 7,
    date: "13.04.2024",
    type: "dialog",
    situation: "old",
    titel: "Ramadan-Event",
    desc: "Als Verein haben wir eine  besondere Veranstaltung  anlässlich des Ramadan-Festes organisiert, an dem Kinder mit ihren Familien teilnehmen konnten. Die Veranstaltung fand in Mönchengladbach im -Kinderspielparadies Ballorig-; ein unterhaltsamer Ort für Kinder, statt. Die Familien zeigten ein großes Interesse an unserer Veranstaltung.",
    desc2:
      "Als Verein haben wir eine  besondere Veranstaltung  anlässlich des Ramadan-Festes organisiert, an dem Kinder mit ihren Familien teilnehmen konnten. Die Veranstaltung fand in Mönchengladbach im -Kinderspielparadies Ballorig-; ein unterhaltsamer Ort für Kinder, statt. Die Familien zeigten ein großes Interesse an unserer Veranstaltung. Während sich die Eltern bei kulinarischen Angeboten angeregt unterhielten, genossen die Kinder das Spielangebot vor Ort. Es entstanden harmonische und unterhaltsame Atmosphäre zwischen den Anwesenden und auch die Kinder hatten die Gelegenheit neue Freundschaften zu knüpfen.Dieser schöne Tag hat dazu beigetragen, dass die Familie samt ihren Kindern eine angenehme Zeit verbringen konnten. Wir danken allen, die an unserem Fest teilgenommen haben.",
    desc3: "",
    image:
      "https://cdn.pixabay.com/animation/2022/11/13/07/16/07-16-41-513_512.gif",
    video: "",
    images: [
      "/images/dialog/dFoto-7.jpg",
      "/images/dialog/dFoto-8.png",
      "/images/dialog/dFoto-9.png",
      "/images/dialog/dFoto-10.png",
      "/images/dialog/dFoto-11.png",
      "/images/dialog/dFoto-12.jpg",
    ],
    time: "...",
  },
  // {
  //   id: 10,
  //   type: "jugend",
  //   situation: "old",
  //   titel: "Hier kommt Schlagzeile",
  //   desc: "Alle jugendliche Aktivitäten des Vereins können in diesem Bereich umfassend präsentiert werden. Unterstützt durch aussagekräftige Videos oder Fotos wird ein lebendiges Bild unserer vielfältigen Veranstaltungen gezeichnet.",
  //   image:
  //     "https://cdn.pixabay.com/photo/2023/11/08/14/03/ai-generated-8374826_640.jpg",
  //   video: "",
  //   images: [
  //     "/images/jugend/jFoto-7.jpg",
  //     "/images/jugend/jFoto-8.jpg",
  //     "/images/jugend/jFoto-9.jpg",
  //     "/images/jugend/jFoto-10.jpg",
  //     "/images/jugend/jFoto-11.jpg",
  //     "/images/jugend/jFoto-12.jpg",
  //   ],
  //   time: "...",
  // },
];

const allInfo = [
  {
    name: "STARTSEITE",
    titel: "STARTSEITE Schlagzeile",
    desc: "STARTSEITE Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_ueber.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2018/11/30/09/40/business-card-3847385_640.jpg",
        titel: "STARTSEITE subInfo Titel",
        desc: "",
      },
    ],
    cardInfo: [
      {
        type: "startseite",
        titel: "STARTSEITE Card Titel",
        datum: "STARTSEITE Card Datum",
        image: "STARTSEITE Card IMAGE",
        subInfo: [
          {
            titel: "STARTSEITE Card subInfo Titel",
            image: "STARTSEITE Card subInfo IMAGE",
            desc: "STARTSEITE Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "ÜBER UNS",
    titel: "ÜBER UNS Schlagzeile",
    desc: "ÜBER UNS Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_ueber.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2018/11/30/09/40/business-card-3847385_640.jpg",
        titel: "Ü U subInfo Titel",
        desc: "",
      },
    ],
    cardInfo: [
      {
        type: "überuns",
        titel: "ÜU Card Titel",
        datum: "ÜU Card Datum",
        image: "ÜU Card IMAGE",
        subInfo: [
          {
            titel: "ÜU Card subInfo Titel",
            image: "ÜU Card subInfo IMAGE",
            desc: "ÜU Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "DIALOG & KULTUR",
    titel: "DIALOG & KULTUR Schlagzeile",
    desc: "DIALOG & KULTUR Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_kultur_dialog.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2020/09/27/16/13/toys-5607032_640.jpg",
        titel: "D & K subInfo Titel",
        desc: "D & K subInfo Lorem ipsum sit amet",
      },
    ],
    cardInfo: [
      {
        type: "dialog",
        titel: "D & K Card Titel",
        datum: "D & K Card Datum",
        image: "D & K Card IMAGE",
        subInfo: [
          {
            titel: "D & K Card subInfo Titel",
            image: "D & K Card subInfo IMAGE",
            desc: "D & K Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "BILDUNG",
    titel: "BILDUNG Schlagzeile",
    desc: "BILDUNG Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_bildung.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2023/03/20/14/51/environment-7864984_640.jpg",
        titel: "BILDUNG subInfo Titel",
        desc: "BILDUNG subInfo Lorem ipsum sit amet",
      },
    ],
    cardInfo: [
      {
        titel: "BILDUNG Card Titel",
        datum: "BILDUNG Card Datum",
        image: "BILDUNG Card IMAGE",
        subInfo: [
          {
            titel: "BILDUNG Card subInfo Titel",
            image: "BILDUNG Card subInfo IMAGE",
            desc: "BILDUNG Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "FLÜCHTLINGSARBEIT",
    titel: "FLÜCHTLINGSARBEIT Schlagzeile",
    desc: "FLÜCHTLINGSARBEIT Lorem ipsum sit amet",
    image:
      "//ebruev.de/wp-content/uploads/2023/03/slider_fluechtlingsarbeit.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2024/02/13/06/33/ai-generated-8570267_640.jpg",
        titel: "FLÜCHTLINGSARBEIT subInfo Titel",
        desc: "FLÜCHTLINGSARBEIT subInfo Lorem ipsum sit amet",
      },
    ],
    cardInfo: [
      {
        titel: "FLÜCHTLINGSARBEIT Card Titel",
        datum: "FLÜCHTLINGSARBEIT Card Datum",
        image: "FLÜCHTLINGSARBEIT Card IMAGE",
        subInfo: [
          {
            titel: "FLÜCHTLINGSARBEIT Card subInfo Titel",
            image: "FLÜCHTLINGSARBEIT Card subInfo IMAGE",
            desc: "FLÜCHTLINGSARBEIT Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "JUGEND & SOZIALES",
    titel: "JUGEND & SOZIALES Schlagzeile",
    desc: "JUGEND & SOZIALES Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_jugend.jpg",
    subInfo: [
      {
        image:
          "https://cdn.pixabay.com/photo/2024/02/15/09/12/ai-generated-8575000_640.png",
        titel: "Jug & SOZ subInfo Titel",
        desc: "Jug & SOZ subInfo Lorem ipsum sit amet",
      },
    ],
    cardInfo: [
      {
        titel: "Jug & SOZ Card Titel",
        datum: "Jug & SOZ Card Datum",
        image: "Jug & SOZ Card IMAGE",
        subInfo: [
          {
            titel: "Jug & SOZ Card subInfo Titel",
            image: "Jug & SOZ Card subInfo IMAGE",
            desc: "Jug & SOZ Card subInfo DESC",
          },
        ],
      },
    ],
  },
  {
    name: "AKTUELLES",
    titel: "AKTUELLES Schlagzeile",
    desc: "AKTUELLES Lorem ipsum sit amet",
    image: "//ebruev.de/wp-content/uploads/2023/03/slider_aktuelles.jpg",
    subInfo: [
      {
        image: "//ebruev.de/wp-content/uploads/2023/03/slider_aktuelles.jpg",
        titel: "AKTUELLES subInfo Titel",
        desc: "AKTUELLES subInfo Lorem ipsum sit amet",
      },
    ],
    cardInfo: [
      {
        titel: "AKTUELLES Card Titel",
        datum: "AKTUELLES Card Datum",
        image: "AKTUELLES Card IMAGE",
        subInfo: [
          {
            titel: "AKTUELLES Card subInfo Titel",
            image: "AKTUELLES Card subInfo IMAGE",
            desc: "AKTUELLES Card subInfo DESC",
          },
        ],
      },
    ],
  },
];

const zitaten = [
  {
    id: 1,
    zitat: "Das Leben besteht aus Augenblicken. Nutze den Moment.",
    autor: "Paulo Coelho",
    image:
      "https://cdn.pixabay.com/photo/2022/07/17/21/25/paulo-coelho-7328348_1280.png",
  },
  {
    id: 2,
    zitat:
      "Das Leben ist wie ein Buch und wer nicht reist, liest nur eine Seite.",
    autor: "Augustinus Aurelius",
    image:
      "https://tse4.mm.bing.net/th?id=OIP.9u6xMEVpSr8KItIfP_T-VwAAAA&pid=Api&P=0&h=180",
  },
  {
    id: 3,
    zitat:
      "Glück entsteht oft durch Aufmerksamkeit in kleinen Dingen, Unglück oft durch Vernachlässigung kleiner Dinge.",
    autor: "Wilhelm Busch",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Busch_F2_%282%29.jpg/220px-Busch_F2_%282%29.jpg",
  },
  {
    id: 4,
    zitat: "Lebe jeden Tag, als wäre es dein letzter.",
    autor: "Mahatma Gandhi",
    image:
      "https://cdn.pixabay.com/photo/2023/02/04/23/14/ai-generated-7768378_1280.jpg",
  },
  {
    id: 5,
    zitat:
      "Das Glück deines Lebens hängt von der Beschaffenheit deiner Gedanken ab",
    autor: "Marcus Aurelius",
    image:
      "https://cdn.pixabay.com/photo/2023/11/15/17/17/ai-generated-8390622_640.jpg",
  },
  {
    id: 6,
    zitat: "In der Mitte von Schwierigkeiten liegen Möglichkeiten",
    autor: "Albert Einstein",
    image:
      "https://cdn.pixabay.com/photo/2024/04/08/18/23/ai-generated-8684145_640.jpg",
  },
  {
    id: 7,
    zitat: "Nichts ist unmöglich, das Wort selbst sagt‚ Ich bin möglich‘!",
    autor: "Audrey Hepburn",
    image:
      "https://cdn.pixabay.com/photo/2016/03/04/03/54/audrey-hepburn-1235442_640.jpg",
  },
  {
    id: 8,
    zitat:
      "Erfolg besteht darin, von Fehler zu Fehler zu gehen, ohne seine Begeisterung zu verlieren.",
    autor: "Winston Churchill",
    image:
      "https://cdn.pixabay.com/photo/2016/04/01/10/17/britain-1299836_1280.png",
  },
  {
    id: 9,
    zitat: "Der beste Weg, die Zukunft vorauszusagen, ist, sie zu gestalten.",
    autor: "Abraham Lincoln",
    image:
      "https://cdn.pixabay.com/photo/2020/07/24/02/51/person-5432770_640.png",
  },
  {
    id: 10,
    zitat:
      "Das Leben ist wie Fahrradfahren. Um das Gleichgewicht zu halten, musst du in Bewegung bleiben.",
    autor: "Albert Einstein",
    image:
      "https://cdn.pixabay.com/photo/2024/04/08/18/23/ai-generated-8684145_640.jpg",
  },
  {
    id: 11,
    zitat:
      "Hindernisse können dich nicht aufhalten. Wenn du auf einen Berg stößt, dann steige drüber.",
    autor: "John Lennon",
    image:
      "https://cdn.pixabay.com/photo/2019/12/11/17/11/john-lennon-4688793_1280.png",
  },
  {
    id: 12,
    zitat:
      "Das Geheimnis des Erfolgs liegt darin, sein Ziel zu kennen und niemals aufzugeben.",
    autor: "Benjamin Franklin",
    image:
      "https://cdn.pixabay.com/photo/2012/10/25/23/17/benjamin-franklin-62846_640.jpg",
  },
  {
    id: 13,
    zitat:
      "Erfolg ist nicht der Schlüssel zum Glück. Glück ist der Schlüssel zum Erfolg. Wenn du liebst, was du tust, wirst du erfolgreich sein.",
    autor: "Albert Schweitzer",
    image:
      "https://cdn.pixabay.com/photo/2021/05/06/22/31/albert-schweitzer-6234657_1280.png",
  },
  {
    id: 14,
    zitat:
      "Glück ist nicht etwas Fertiges. Es kommt von deinen eigenen Handlungen.",
    autor: "Dalai Lama",
    image:
      "https://cdn.pixabay.com/photo/2017/04/20/07/35/dalai-lama-2244829_640.jpg",
  },
  {
    id: 15,
    zitat: "Das Glück ist keine Zielstation, sondern eine Art zu reisen.",
    autor: "Roy Goodman",
    image:
      "https://tse4.mm.bing.net/th?id=OIP.W4_DhMDMxfSbvhsvOvBnSgAAAA&pid=Api&P=0&h=180",
  },
  {
    id: 16,
    zitat:
      "Sei dankbar für das, was du hast; du wirst mehr davon bekommen. Wenn du dich auf das konzentrierst, was du nicht hast, wirst du niemals genug haben.",
    autor: "Oprah Winfrey",
    image:
      "https://tse1.mm.bing.net/th?id=OIP.iJFl9CYaJaqw7Pvu7XvpfgHaE8&pid=Api&P=0&h=180",
  },
  {
    id: 17,
    zitat: "Der wahre Erfolg im Leben ist, glücklich zu sein.",
    autor: "Dalai Lama",
    image:
      "https://cdn.pixabay.com/photo/2017/04/20/07/35/dalai-lama-2244829_640.jpg",
  },
  {
    id: 18,
    zitat:
      "Lebe im Jetzt, denn das ist alles, was du hast. Gestern ist vorbei, morgen kommt noch.",
    autor: "Eleanor Roosevelt",
    image:
      "https://tse3.mm.bing.net/th?id=OIP.VYdlUTg3GsW2DMVgYZvfxQHaEK&pid=Api&P=0&h=180",
  },
  {
    id: 19,
    zitat:
      "Die Zeit vergeht so schnell, dass wir manchmal vergessen, den Moment zu schätzen, den wir gerade erleben.",
    autor: "Unbekannt",
    image: "",
  },
  {
    id: 20,
    zitat:
      "Das Geheimnis des Glücks liegt in der Freude, die wir anderen bereiten.",
    autor: "Alexandre Dumas",
    image:
      "https://tse3.explicit.bing.net/th?id=OIP.OPPATetMyJ3x_EWmb2PSMgHaEK&pid=Api&P=0&h=180",
  },
];

const projekte = [
  {
    id: 1,
    situation: "full",
    type: "projekt",
    name: "Bilder aus der neuen Heimat",
    titel: "Bilder aus der neuen Heimat",
    titel2: "Projektbeschreibung",
    titel3: "Zielstellung",
    desc: "Gemeinsam Neuss entdecken – Sprache und Vertrauen stärken",
    desc2:
      "Neuss ist für viele neu zugewanderte Kinder eine neue Heimat geworden. Unser Projekt lädt diese Kinder ein, ihre Stadt auf kreative Weise zu entdecken, Erlebnisse festzuhalten und dabei Sprache, Selbstvertrauen und Gemeinschaft zu stärken.",
    desc3:
      "Das Projekt richtet sich an Kinder mit Fluchterfahrung, die neu nach Deutschland zugewandert sind. Ziel ist es, ihre Wahrnehmung für die neue Umgebung zu schärfen und eigene Perspektiven zu entwickeln. Durch kreative Stadterkundung – insbesondere mit Fotografie – werden sprachliche, soziale und interkulturelle Kompetenzen gestärkt. So können die Kinder die Welt mit neuen Augen entdecken und sich kreativ ausdrücken.",
    desc4:
      "Für neu zugewanderte Kinder ist es entscheidend, die eigene Umgebung nicht nur kennenzulernen, sondern auch mit ihr in Beziehung zu treten. Dieses Projekt schafft dafür einen geschützten, partizipativen Rahmen, in dem die Kinder die Stadt Neuss mit ihrer eigenen Sichtweise erkunden, dokumentieren und präsentieren können. Das zentrale Medium ist die Fotografie – eine niedrigschwellige, kreative Ausdrucksform, die Beobachtung, Auswahl, Reflexion und Kommunikation miteinander verbindet. Im Laufe der Woche sammeln die Kinder Eindrücke, entdecken Orte, die für sie Bedeutung haben, und lernen diese mit Worten und Bildern darzustellen. Dabei entwickeln sie sprachliche Fähigkeiten, stärken ihre soziale Interaktion und lernen, sich in einem Gruppenkontext auszudrücken und zu behaupten. Die eigene Sicht auf die Stadt sichtbar zu machen, vermittelt ein Gefühl von Einfluss, Teilhabe und Wertschätzung. Langfristig unterstützt das Projekt die emotionale Bindung zur neuen Heimatstadt, fördert die Selbstwirksamkeit und erweitert die Fähigkeit, Beobachtetes in eigene Worte zu fassen. Durch Präsentation und Ausstellung der Ergebnisse wird der individuelle Beitrag jedes Kindes anerkannt und öffentlich gewürdigt – ein wichtiger Schritt für Zugehörigkeit und Selbstbewusstsein.",
    image: "/images/projekte/heimat/heimat-1.jpg",
    video: "",
    images: [
      "/images/projekte/heimat/heimat-1.jpg",
      "/images/projekte/heimat/gefördertDurch.jpeg",
    ],
    time: "...",
  },
  {
    id: 2,
    situation: "full",
    type: "projekt",
    name: "»2.000 X 1.000 EURO FÜR DAS ENGAGEMENT«",
    titel: "Engagement",
    titel2:
      "Zukunftswege: Gemeinsam gestlaten, 2.000 x 1.000 Euro für das Engagement",
    titel3: "Zielgruppe",
    titel4: "Ziele",
    titel5: "Ablauf",
    desc: "»2.000 x 1.000 Euro für das Engagement«",
    desc2:
      "Die Landesregierung NRW startete 2021 mit ersten Maßnahmen zur Umsetzung der Engagementstrategie. Ein wichtiger Bestandteil ist das Förderprogramm »2.000 x 1.000 Euro für das Engagement«, das jedes Jahr unter einem besonderen Schwerpunktthema umgesetzt wird. 2025 lautet dieses Thema: „Engagiert in die Zukunft – junges Engagement fördern und neue Projekte gestalten“. Gefördert werden Projekte, die von jungen Menschen selbst umgesetzt werden oder gezielt junges Engagement stärken.",
    desc3:
      "Im Rahmen dieses Förderprogramms bauen wir im Harmonie Kulturzentrum einen Jugendclub auf, der Kindern im Alter von 9 bis 13 Jahren frühzeitig ein Bewusstsein für freiwilliges Engagement und gesellschaftliche Teilhabe vermittelt. Besonders Kinder aus Familien mit Migrationsgeschichte werden aktiv in das Projekt einbezogen, um ihre Integration zu fördern und ihre Rolle als verantwortungsvolle Mitglieder der Gesellschaft zu stärken.",
    desc4:
      "Die geplanten Aktivitäten orientieren sich an einem pädagogischen Ansatz, der die individuelle Entwicklung der Kinder unterstützt und auf partizipatives, erfahrungsorientiertes Lernen setzt. In begleiteten Workshops lernen die Kinder:",
    desc41: "gemeinsam Entscheidungen zu treffen,",
    desc42: "eigene Ideen zu äußern,",
    desc43: "Verantwortung zu übernehmen,",
    desc44: "im Team kreative Lösungen zu entwickeln.",
    desc5:
      "Dieser Beteiligungsprozess stärkt ihr Selbstvertrauen, ihre sozialen Kompetenzen und hilft ihnen, die eigenen Potenziale zu erkennen.",
    desc6:
      "Bei den monatlichen Treffen (jeweils ca. 2 Stunden) werden sowohl inhaltliche Workshops (z. B. „Was bedeutet Teilhabe?“, „Wie planen wir gemeinsam?“) als auch praktische und kreative Aktivitäten (z. B. Plakatgestaltung, Präsentationsvorbereitung, Organisation eines Spielnachmittags) durchgeführt. Dabei übernehmen die Kinder konkrete Aufgaben bei der Planung und Umsetzung kleiner Veranstaltungen – eine wertvolle Erfahrung für ihr Verantwortungsbewusstsein.",
    desc7:
      "Das Projekt legt den Grundstein für einen nachhaltigen Kinder- und Jugendclub innerhalb des Vereins und ermöglicht den Teilnehmenden erste, positiv begleitete Erfahrungen im Bereich Ehrenamt.",
    image: "/images/projekte/engagement/engagementHarmonie.jpeg",
    video: "",
    images: ["/images/projekte/engagement/engagementHarmonie.jpeg"],
    time: "01.09.2025 – 31.12.2025",
  },
  {
    id: 3,
    situation: "full",
    type: "projekt",
    titel: "Demokratie",
    titel2: "Projektbeschreibung",
    titel3: "Zielgruppe",
    titel4: "Ziele",
    titel5: "Ablauf",
    desc: "Junge Stimmen für die Demokratie",
    desc2:
      "Das Ziel dieses Projekts ist es, den Kindern die wesentlichen Prinzipien der Demokratie näherzubringen und sie dazu zu ermutigen, diese Werte aktiv im Alltag zu leben. Dabei wird der Schwerpunkt auf der praktischen Umsetzung von Demokratie gelegt, sodass die Kinder nicht nur theoretisches Wissen über demokratische Prozesse erwerben, sondern diese auch in ihrem täglichen Leben erfahren. Im Rahmen von Seminaren und interaktiven Aktivitäten sollen sie ein tiefgehendes Verständnis für zentrale demokratische Werte wie Gleichberechtigung, Freiheit, Mitbestimmung und Verantwortung entwickeln. Die Kinder werden angeregt, die Bedeutung dieser Werte zu reflektieren und zu erkennen, wie sie diese in ihrem sozialen Umfeld anwenden können. Das Projekt fördert nicht nur das politische Bewusstsein der Kinder, sondern unterstützt sie auch dabei, Fähigkeiten wie Teamarbeit, kritisches Denken und Kommunikation zu entwickeln. Am Ende des Projekts werden die Kinder in der Lage sein, sich als verantwortungsbewusste und aktive Mitglieder der Gesellschaft zu engagieren und so einen positiven Beitrag zur demokratischen Kultur zu leisten.",
    desc3:
      "Die Zielgruppe unseres Projekts sind Jugendliche im Alter von 9 bis 13 Jahren, insbesondere Kinder aus Migrantenfamilien. Diese Jugendlichen sind häufig mit Herausforderungen wie sozialer Integration und kulturellen Unterschieden konfrontiert. Unser Projekt soll ihnen helfen, demokratische Werte zu verstehen, ihr politisches Engagement zu fördern und ihre gesellschaftliche Teilhabe zu stärken. Dadurch möchten wir ihre Integration und Verantwortungsbewusstsein in der Gesellschaft unterstützen.",
    desc41: "Erlernen demokratischer Prinzipien",
    desc42: "Förderung der gesellschaftlichen Teilhabe",
    desc43: "Entwicklung von Mitbestimmung und Verantwortung",
    desc51: "Woche – Einführung in Demokratie und gesellschaftliche Teilhabe",
    desc511:
      "Einführung der Begriffe Demokratie und gesellschaftliche Teilhabe",
    desc512: "Aufteilung der Kinder in vier Gruppen (je 6-8 Personen)",
    desc513: "Vertiefung der Konzepte durch Spiele und Diskussionen",
    desc52: "Woche – Wahlprozess und Vorbereitung der Präsidentschaftswahl",
    desc521: "Vermittlung des Wahlprozesses",
    desc522:
      "Wahl eines Kandidaten in jeder Gruppe und Vorbereitung einer Rede",
    desc523: "Erstellung von Wahlmaterialien (Slogans, Poster, Broschüren)",
    desc524: "Diskussion über den Wahlprozess",
    desc53: "Woche – Wahlkampagne und Vorstellung der Kandidaten",
    desc531: "Vorstellung der Kandidaten und ihrer Programme",
    desc532:
      "Durchführung einer Debatte, in der Kandidaten ihre Programme verteidigen",
    desc54: "Woche – Präsidentschaftswahl und Ergebnisse",
    desc541: "Durchführung der geheimen Wahl",
    desc542: "Vorstellung der Projekte des gewählten Präsidenten",
    image: "/images/projekte/demokratie/demokratie-1.jpg",
    link: "https://www.dkhw.de/foerderung-und-hilfe/projektfoerderung/sonderfonds-u18/",
    video:
      "https://www.dkhw.de/foerderung-und-hilfe/projektfoerderung/sonderfonds-u18/",
    images: [
      "/images/projekte/demokratie/demokratie-1.jpg",
      "/images/projekte/demokratie/demokratie-2.jpeg",
    ],
    time: "...",
  },
  {
    id: 4,
    situation: "full",
    type: "projekt",
    name: "Anschubförderung",
    titel: "Anschubförderung",
    titel2: "",
    titel3: "Zielgruppe",
    titel4: "Ziele",
    titel5: "Ablauf",
    desc: "Stärkung von Integration und Teilhabe",
    desc2:
      "Das Projekt hat das Ziel, die Integration von Menschen mit Migrationshintergrund zu fördern und ihre aktive Teilhabe am gesellschaftlichen Leben zu stärken. Die Zielgruppen sind erwachsene Migrantinnen und Migranten sowie Kinder und Jugendliche. Schwerpunkte des Projekts liegen auf Seminaren und Workshops zu Themen wie Datenschutz, Erste Hilfe, Organisationsfähigkeiten und Mentoring. Zusätzlich sind Dialogmaßnahmen und Aktivitäten geplant, um die Beziehungen der Teilnehmenden zur Gesellschaft nachhaltig zu verbessern. Deswegen beabsichtigen wir unser technisches Fundament auszubauen.",
    desc3:
      "Unser Verein Harmonie e.V., der im Jahr 2023 gegründet wurde, setzt sich dafür ein, dass Menschen mit Migrationsgeschichte stärkere Bindungen zur Gesellschaft aufbauen und aktiv am gesellschaftlichen Leben teilhaben können. Um unsere Aktivitäten als junger Verein weiter auszubauen und nachhaltiger zu gestalten, haben wir einen Projektantrag gestellt, der nun bewilligt wurde.",
    desc4:
      "Im Rahmen der vom Ministerium für Kinder, Jugend, Familie, Gleichstellung, Flucht und Integration des Landes NRW ausgeschriebenen Anschubförderung/ Anschubprojekt erhalten wir eine Förderung, die darauf abzielt, die institutionellen Kapazitäten junger Vereine von Menschen mit Einwanderungsgeschichte-die innerhalb der letzten fünf Jahre ins Vereinsregister eingetragen wurden-zu stärken.",
    desc5:
      "Dank dieser Projektförderung können wir unseren Verein mit dringend benötigten Laptops, Druckern, Büro-und Spielmaterialien sowie MaBnahmen im Bereich der Öffentlichkeitsarbeit ausstatten und so die Effizienz unserer Arbeit steigern.",
    desc6:
      "Darüber hinaus werden im Rahmen des Projekts Seminare und Workshops für verschiedene Altersgruppen angeboten.Themen wie Datenschutz, Erste Hilfe, Organisationsfähigkeiten und Mentoring stehen dabei im Mittelpunkt, um die persönliche wie auch gesellschaftliche Entwicklung der Teilnehmenden zu fördern. Ergänzend dazu werden Dialogmaßnahmen, kulturelle Begegnungen und gemeinsame Aktivitäten durchgeführt, die Brücken zwischen Menschen mit und ohne Migrationsgeschichte schlagen und ein besseres gegenseitiges Verständnis sowie eine Kultur des Zusammenlebens stärken sollen.",
    desc7:
      "Mit diesem Projekt wird die technische Infrastruktur unseres Vereins verbessert, ein stabiles Fundament für nachhaltige Arbeit geschaffen und neue Möglichkeiten eröffnet, damit Menschen mit Migrationsgeschichte ihr Potenzial entfalten und aktiv zur gesellschaftlichen Teilhabe beitragen können.",
    desc8:
      "Unser Projekt wird durch das Ministerium für Kinder, Jugend, Familie, Gleichstellung, Flucht und Integration des Landes NRW gefördert.",
    image: "/images/projekte/anschubförderung/anschubförderung-2025.jpeg",
    video: "",
    images: ["/images/projekte/anschubförderung/anschubförderung-2025.jpeg"],
    time: "01.07.2025 – 31.12.2025",
  },
  {
    id: 5,
    situation: "null",
    type: "projekt",
    name: "»2.000 X 1.000 EURO FÜR DAS ENGAGEMENT«",
    titel: "Engagement",
    titel2:
      "Zukunftswege: Gemeinsam gestlaten, 2.000 x 1.000 Euro für das Engagement",
    titel3: "Zielgruppe",
    titel4: "Ziele",
    titel5: "Ablauf",
    desc: "»2.000 x 1.000 Euro für das Engagement«",
    desc2: "",
    desc3: "",
    desc4:
      "Die geplanten Aktivitäten orientieren sich an einem pädagogischen Ansatz, der die individuelle Entwicklung der Kinder unterstützt und auf partizipatives, erfahrungsorientiertes Lernen setzt. In begleiteten Workshops lernen die Kinder:",
    desc41: "gemeinsam Entscheidungen zu treffen,",
    desc42: "eigene Ideen zu äußern,",
    desc43: "Verantwortung zu übernehmen,",
    desc44: "im Team kreative Lösungen zu entwickeln.",
    desc5:
      "Dieser Beteiligungsprozess stärkt ihr Selbstvertrauen, ihre sozialen Kompetenzen und hilft ihnen, die eigenen Potenziale zu erkennen.",
    desc6:
      "Bei den monatlichen Treffen (jeweils ca. 2 Stunden) werden sowohl inhaltliche Workshops (z. B. „Was bedeutet Teilhabe?“, „Wie planen wir gemeinsam?“) als auch praktische und kreative Aktivitäten (z. B. Plakatgestaltung, Präsentationsvorbereitung, Organisation eines Spielnachmittags) durchgeführt. Dabei übernehmen die Kinder konkrete Aufgaben bei der Planung und Umsetzung kleiner Veranstaltungen – eine wertvolle Erfahrung für ihr Verantwortungsbewusstsein.",
    desc7:
      "Das Projekt legt den Grundstein für einen nachhaltigen Kinder- und Jugendclub innerhalb des Vereins und ermöglicht den Teilnehmenden erste, positiv begleitete Erfahrungen im Bereich Ehrenamt.",
    image:
      "https://cdn.pixabay.com/photo/2015/09/09/20/40/drawing-933207_640.jpg",
    video: "",
    images: [],
    time: "...",
  },
  {
    id: 6,
    situation: "full",
    type: "projekt",
    name: "Kermes!",
    titel: "Kermes!",
    desc: "Ein herzlicher Rückblick auf unseren erfolgreichen Kermes!",
    desc2:
      "Am 8, 9 und 10. November 2024 haben wir als Gemeinschaft einen unvergesslichen Kermes organisiert, der ein voller Erfolg war! 🌟",
    desc3:
      "Der Tag war geprägt von leckerem Essen, guter Stimmung und einem großartigen Zusammenhalt. Unsere Besucher konnten sich an einer Vielzahl von Köstlichkeiten erfreuen, darunter saftiger Cağ Kebab (Döner), köstliche Lahmacun, zarte Hähnchenspieße, herzhafte Köfte, süße Desserts und frisch zubereitete Waffeln. Natürlich durfte es auch an erfrischenden Getränken nicht fehlen. 🍢🍩🥤",
    desc4:
      "Für den Komfort unserer Gäste sorgten gemütliche Sitzbereiche, in denen man das Essen und die Geselligkeit in Ruhe genießen konnte. 🪑☀️",
    desc5:
      "Besonders beeindruckend war das Engagement unserer Vereinsmitglieder und freiwilligen Helfer. Mit vollem Einsatz und viel Herzblut haben sie zahlreiche Aufgaben übernommen und somit den Erfolg dieser Veranstaltung ermöglicht. 🙌💪",
    desc6:
      "Wir danken allen, die Teil dieses besonderen Tages waren – sei es als Besucher, Helfer oder Unterstützer. Gemeinsam haben wir nicht nur einen schönen Tag erlebt, sondern auch gezeigt, wie stark unsere Gemeinschaft ist.",
    desc7:
      "Wir freuen uns schon jetzt auf die nächsten Veranstaltungen und hoffen, euch bald wieder willkommen heißen zu dürfen! 😊",
    image: "/images/projekte/kermes/Image-0.jpg",
    video: "",
    images: [
      "/images/projekte/kermes/Image-0.jpg",
      "/images/projekte/kermes/Image-1.jpeg",
      "/images/projekte/kermes/Image-2.jpeg",
      "/images/projekte/kermes/Image-3.jpeg",
      "/images/projekte/kermes/Image-4.jpeg",
      "/images/projekte/kermes/Image-6.jpeg",
      "/images/projekte/kermes/Image-8.jpeg",
      "/images/projekte/kermes/Image-9.jpeg",
      "/images/projekte/kermes/Image-10.jpeg",
      "/images/projekte/kermes/Image-11.jpeg",
    ],
    time: "(8-9-10).11.2024",
  },
  {
    id: 7,
    situation: "null",
    name: "",
    titel: "Engagement Global",
    desc: "Globale Ursachen von Flucht und Migration und Menschenrechte",
    desc1:
      "Das Projekt <b>„Globale Ursachen von Flucht und Migration und Menschenrechte“</b> wird von <b>Harmonie e.V.</b> durchgeführt und richtet sich an Erwachsene aus der lokalen Bevölkerung. Ziel des Projekts ist es, ein vertieftes Verständnis für die globalen Ursachen von Flucht und Migration aus einer menschenrechtlichen Perspektive zu schaffen. Im Mittelpunkt stehen Themen wie Krieg, politische Verfolgung, Diskriminierung, strukturelle Ungleichheiten sowie geschlechtsspezifische Gewalt als zentrale Ursachen von Fluchtbewegungen. Durch Bildungs- und Dialogformate sollen die Teilnehmenden sensibilisiert und zur aktiven Auseinandersetzung mit globalen Zusammenhängen angeregt werden.",
    desc2:
      "Das Projekt möchte aufzeigen, dass Flucht und Migration häufig nicht auf individuellen Entscheidungen beruhen, sondern eine Folge von Menschenrechtsverletzungen, Unsicherheit und fehlendem Schutz sind. Die Teilnehmenden sollen für globale Verantwortung sensibilisiert und dazu ermutigt werden, unterschiedliche Perspektiven wahrzunehmen und zu reflektieren. Gleichzeitig fördert das Projekt Empathie, kritisches Denken und den Austausch über menschenrechtliche Fragestellungen in einer vielfältigen Gesellschaft.",
    desc3:
      "Das Projekt umfasst sechs aufeinander aufbauende Veranstaltungen, die im Laufe des Jahres 2026 umgesetzt werden. Die inhaltliche Struktur folgt dem Prinzip der Sensibilisierung, Vertiefung und Reflexion.",
    desc4:
      "Den Auftakt bildet die Veranstaltung <b>„Frauen & Fluchtursachen“.</b>  In diesem thematischen Einstieg werden geschlechtsspezifische Fluchtursachen, strukturelle Diskriminierung sowie die besondere Betroffenheit von Frauen im Kontext von Flucht und Migration behandelt.",
    desc5:
      "Im Rahmen des Programms <b>„Filmabend – Migration & Menschenrechte“</b> wird ein thematisch passender Film gezeigt. Im Anschluss findet ein moderierter Austausch in offener Gesprächsatmosphäre statt, um die gezeigten Inhalte gemeinsam zu reflektieren.",
    desc6:
      "Mit der Veranstaltung <b>„Erfahrung & Analyse von Fluchtursachen“</b> rückt das Erfahrungslernen in den Mittelpunkt. Persönliche Berichte und moderierte Gespräche ermöglichen eine vertiefte Auseinandersetzung mit individuellen Flucht- und Migrationserfahrungen.",
    desc7:
      "Ein besonderer Bestandteil des Projekts ist die <b>Bildungsexkursion zum NS-Dokumentationszentrum Köln</b> unter dem Titel <b>„Erinnerung, Ausgrenzung und Zwangsmigration“.</b> Dabei werden historische und gegenwärtige Formen von Ausgrenzung, Verfolgung und Menschenrechtsverletzungen miteinander in Beziehung gesetzt.",
    desc8:
      "Mit der Veranstaltung <b>„Fotoausstellung & Diskussion“</b> werden Bilder und visuelle Eindrücke zu Flucht, Migration und Menschenrechten präsentiert. Die Ausstellung schafft Raum für Austausch, Diskussion und persönliche Reflexion.",
    desc9:
      "Den Abschluss bildet die Informationsveranstaltung <b>„Menschenrechte & Zwangsmigration“.</b> Hier werden aktuelle Menschenrechtsverletzungen in verschiedenen Weltregionen thematisiert und globale Zusammenhänge von Flucht, Verantwortung und Solidarität gemeinsam reflektiert.",
    desc10:
      "Gefördert durch <b>Engagement Global</b> mit Mitteln des <b>Bundesministeriums für wirtschaftliche Zusammenarbeit und Entwicklung (BMZ).</b>",
    desc11:
      "Die Inhalte geben nicht den Standpunkt von Engagement Global oder des BMZ wieder.",
    image: "/images/projekte/engagement/teefarm-map-1974699.png",
    video: "",
    images: [],
    time: "16.02.2026 bis 31.12.2026",
    time2: "März 2026:",
    time3: "Juni 2026:",
    time4: "September 2026:",
    time5: "Oktober 2026:",
    time6: "November 2026:",
    time7: "Dezember 2026:",
  },
  {
    id: 8,
    situation: "null",
    name: "",
    titel: "Projekt",
    desc: "Kommt bald!",
    desc2: "Kommt bald!",
    image:
      "https://cdn.pixabay.com/photo/2016/12/02/02/10/idea-1876659_640.jpg",
    video: "",
    images: [],
    time: "...",
  },
];

export { hauptInfo, allInfo, zitaten, projekte };
